import LanguageSelector from '../i18n/LanguageSelector';
import { useAppTranslation } from '../i18n/useAppTranslation';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, TextField, Button, Typography, Box, Alert, Paper, InputAdornment
} from '@mui/material';
import { Email, ArrowBack, SportsScore } from '@mui/icons-material';
import { publicApi as api } from '../services/api';

const ForgotPassword = () => {
  const { tr } = useAppTranslation();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/users/forgot-password/', { email });
      setSubmitted(true);
    } catch (err: any) {
      if (err.code === 'ERR_NETWORK') {
        setError('Impossible de contacter le serveur.');
      } else {
        setError(String(err.response?.data?.error || err.response?.data?.detail || err.response?.data?.email || 'Impossible d’envoyer le lien. Veuillez réessayer.'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)' }}>
      <Container maxWidth="xs">
        <Paper elevation={24} sx={{ p: 4, borderRadius: 4, bgcolor: 'background.paper' }}>
<LanguageSelector/>

          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <SportsScore sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
            <Typography variant="h5" fontWeight={800} gutterBottom>{tr("Mot de passe oublié")}</Typography>
            <Typography variant="body2" color="text.secondary">
               {tr("Saisis ton adresse email et nous t'enverrons un lien pour réinitialiser ton mot de passe.")} </Typography>
          </Box>

          {submitted ? (
            <Box sx={{ textAlign: 'center' }}>
              <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
                 {tr("Si cet email est associé à un compte, un lien de réinitialisation a été envoyé. Vérifie ta boîte mail (et les spams).")} </Alert>
              <Button fullWidth variant="contained" onClick={() => navigate('/login')} sx={{ borderRadius: 2, py: 1.5 }}>
                 {tr("Retour à la connexion")} </Button>
            </Box>
          ) : (
            <Box component="form" onSubmit={handleSubmit}>
              {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{typeof error === 'string' ? tr(error) : error}</Alert>}
              <TextField
                margin="normal"
                required
                fullWidth
                label={tr("Adresse email")}
                type="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email color="action" />
                    </InputAdornment>
                  )
                }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                disabled={loading}
                sx={{ mt: 3, mb: 2, py: 1.5, borderRadius: 2, fontWeight: 700 }}
              >
                {loading ? tr("Envoi en cours...") : tr("Envoyer le lien")}
              </Button>
              <Button
                fullWidth
                variant="text"
                startIcon={<ArrowBack />}
                onClick={() => navigate('/login')}
                sx={{ borderRadius: 2 }}
              >
                 {tr("Retour à la connexion")} </Button>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default ForgotPassword;
